import axios from "axios";
import { toast } from "react-toastify";
import { handleSchedulingStatus } from "../../../slice/planSlice";
import PLAN_URL from "../../../utils/PLAN_URL";

function formatTimeMs(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours === 0 && minutes === 0) {
    return `${seconds}초`;
  }
  if (hours === 0) {
    return `${minutes}분 ${seconds}초`;
  }
  return `${hours}시 ${minutes}분 ${seconds}초`;
}

export const useScheduling = (
  isCancelled,
  openSnackbar,
  setUpdateStatus,
  group_code,
  project_code,
  setLoading,
  setLoadingMessage,
  loadingMessage,
  dispatch
) => {
  const handleDoScheduling = async (
    data,
    excludedOrderIds,
    doSchedulingMutation
  ) => {
    if (!data.length) {
      openSnackbar(
        "주문이 존재하지 않습니다. 주문을 추가 후 다시 시도해 주세요.",
        "info"
      );
      return;
    }
    isCancelled.current = false;
    if (isCancelled.current) return;
    setLoading(true);
    try {
      const bodyObj = {
        excludeOrders: excludedOrderIds,
        project_code,
        group_code,
      };
      await doSchedulingMutation.mutateAsync(bodyObj, {
        onError: (error) => {
          setLoading(false);
          console.log(`onError`);
          let errorMessage =
            "스케줄링 데이터를 생성하던 도중 에러가 발생하였습니다.";
          try {
            if (error && error.response) {
              if (error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
              } else if (typeof error.response.data === "string") {
                errorMessage = error.response.data;
              } else if (error.response.status) {
                errorMessage = `서버 오류가 발생했습니다 (${error.response.status}).`;
              }
            } else if (error && error.message) {
              errorMessage = error.message;
            }
          } catch (e) {
            console.error("에러 메시지 파싱 중 오류 발생:", e);
            errorMessage = "알 수 없는 오류가 발생했습니다.";
          }
          toast.error(errorMessage);
        },
      });
      ///////////////////////////////////////////////////
      if (isCancelled.current) return;
      // dispatch(setSchDirection(selectedModel.id === "bwd" ? "Bwd" : "Fwd"));
      const res = await axios.post(PLAN_URL + "/api/plan/start", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          group_code,
          project_code,
          //  date: dateValue?.format("YYYY-MM-DD HH:mm"),
        },
      });
      // const res = await axios.post(`https://aitest.s-prodis.com/startSch`, {
      //   direction: selectedModel.learning_direction,
      // });
      // await axios.put(APS_URL + "/api/rule/updateStamp", {
      //   params: { group_code, project_code },
      // });
      if (isCancelled.current) return;
      if (res.data.message === "작업이 시작되었습니다.") {
        toast.success(res.data.message);
        setLoadingMessage("생산계획 수행을 요청하였습니다.");
        startStatusCheck();
        const statusParams = {
          isScheduling: true,
          processStatus: 1,
        };
        dispatch(handleSchedulingStatus(statusParams));
      } else if (res.data.message === "이미 동작중입니다.") {
        openSnackbar(res.data.message);
      } else if (res.data.message === "DB 요청 권한이 없습니다.") {
        setLoading(false);
        openSnackbar(res.data.message, "info");
      } else if (!res.data.success) {
        openSnackbar(res.data.message, "error");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      openSnackbar("오류가 발생했습니다.", "error");
      console.log(error);
    }
  };
  const startStatusCheck = (selectedModel) => {
    const intervalId = setInterval(async () => {
      try {
        if (isCancelled.current) return;
        const statusRes = await axios.get(
          PLAN_URL +
            `/api/plan/status?group_code=${group_code}&project_code=${project_code}`
        );
        const { code } = statusRes.data.status;
        // if (statusRes.data.isDirectionTwo) {
        //   if (statusRes.data.isGenerateNumber === 1) {
        //     // 처음 bwd 진행중. 인터벌 계속 진행.
        //     setLoadingMessage("Backward 방향 계획 수립을 진행중입니다.");
        //     if (code === 3) {
        //       // 처음 bwd 완료. loading 은 끊지말고 계속 하되,
        //       // 다시 start 호출 + 인터벌 종료?
        //       // clearInterval(intervalId);
        //       const secondReqRes = await axios.post(
        //         APS_URL + "/api/plan/start",
        //         {
        //           method: "POST",
        //           headers: {
        //             "Content-Type": "application/json",
        //           },
        //           body: {
        //             group_code,
        //             project_code,
        //             model_id: selectedModel.model_id,
        //             isSecond: true,
        //           },
        //         }
        //       );
        //       if (secondReqRes.data.message === "작업이 시작되었습니다.") {
        //         setLoadingMessage(
        //           "Backward 계획 수립을 완료하고 Forward 계획 수립을 요청하였습니다."
        //         );
        //       }
        //     }
        //   } else if (statusRes.data.isGenerateNumber === 2) {
        //     // 그 다음 Fwd 진행중.
        //     setLoadingMessage("Forward 계획 수립을 진행중입니다.");
        //     if (code === 3) {
        //       // 아예 종료.
        //       console.log("statusRes.data.finTime : ", statusRes.data.finTime);
        //       const msTime = formatTimeMs(statusRes.data.finTime);
        //       // toast.success(`완료되었습니다. 소요시간: ${msTime}`);
        //       setLoadingMessage("");
        //       setLoading(false);
        //       openSnackbar("생산계획 생성을 완료하였습니다.");
        //       clearInterval(intervalId);
        //       handleCompletion(msTime);
        //     }
        //   }
        // } else {
        if (code === 1) {
          if (loadingMessage !== "생산계획 수행을 요청하였습니다.") {
            setLoadingMessage("생산계획 수행을 요청하였습니다.");
          }
        }
        if (code === 2) {
          setLoadingMessage("AI가 생산계획을 수립하는 중입니다.");
        }
        if (code === 3) {
          handleCompletion(statusRes.data.progress.formatted);
          clearInterval(intervalId);
          setUpdateStatus((prev) => !prev);
          setLoading(false);
          setLoadingMessage("");
          // itw_demo_ese_layout.itw_apsinfo 업데이트 부분
          // const res = await axios.post(APS_URL + "/api/dt/generate", {
          //   method: "POST",
          //   headers: {
          //     "Content-Type": "application/json",
          //   },
          //   body: { group_code: group_code, project_code: project_code },
          // });
          // openSnackbar(res.data.message);
        }
        //    }
      } catch (error) {
        console.error("Status check error:", error);
        clearInterval(intervalId);
        setLoading(false);
      }
    }, 5000);
  };
  const handleCompletion = (elapsedTime) => {
    toast.success(`완료되었습니다. 소요시간 : ${elapsedTime}`);
    dispatch(handleSchedulingStatus());
    setLoading(false);
  };
  const handleCancelScheduling = async (selectedModel) => {
    isCancelled.current = true;
    try {
      // const directionType = selectedModel.id === "bwd" ? "Bwd" : "Fwd";
      const res = await axios.post(PLAN_URL + "/api/plan/cancel", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          group_code,
          project_code,
        },
      });
      const statusParams = {
        isScheduling: true,
        processStatus: 9,
      };
      const completeStatusParams = {
        isScheduling: false,
        processStatus: 0,
      };
      if (
        res.data.message === "작업 취소가 요청되었습니다." &&
        res.data.success
      ) {
        dispatch(handleSchedulingStatus(statusParams));
        setLoadingMessage("생산계획 수립 취소를 요청하였습니다.");
        const intervalId = setInterval(async () => {
          try {
            if (!isCancelled.current) return;
            const statusRes = await axios.get(
              PLAN_URL +
                `/api/plan/status?group_code=${group_code}&project_code=${project_code}`
            );
            const { status } = statusRes.data;
            if (status.code === 9) {
              dispatch(handleSchedulingStatus(completeStatusParams));
              setLoading(false);
              openSnackbar("생산계획 생성을 취소하였습니다.", "info");
              setLoadingMessage("");
              clearInterval(intervalId);
            }
          } catch (error) {
            console.error("Status check error:", error);
            clearInterval(intervalId);
            setLoading(false);
            setLoadingMessage("");
            dispatch(handleSchedulingStatus(completeStatusParams));
            openSnackbar("취소 중 오류가 밣생하였습니다.", "error");
          }
        }, 5000);
      }
      if (res.data.message === "작업이 취소되었습니다.") {
        dispatch(handleSchedulingStatus(completeStatusParams));
        setLoading(false);
        toast.success("취소가 완료되었습니다.");
      }
      if (res.data.message === "이미 정지 상태입니다.") {
        dispatch(handleSchedulingStatus(completeStatusParams));
        setLoading(false);
        toast.success("취소가 완료되었습니다.");
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };
  return {
    handleDoScheduling,
    handleCancelScheduling,
    setLoading,
  };
};
